<template>
  <div>
    <div class="ms-input-textbox" :class="{ active: isActive }">
      <input
        type="text"
        :disabled="disabled"
        :placeholder="placeHolder"
        class="form-control ms-input-text NKT-P2"
        v-model="text"
      />
      <button v-if="!isActive" class="btn-clear ms-rotate-icon" aria-label="Clear search">
        <img src="@/assets/svg/search.svg" class="icon" />
      </button>
      <button
        v-if="isActive"
        class="btn-clear ms-rotate-icon"
        @click="clearText"
        aria-label="Clear search"
      >
        <img src="@/assets/svg/cancel.svg" class="icon" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, defineProps, defineEmits } from 'vue'
import { watchDebounced } from '@vueuse/core'

const props = defineProps({
  initialText: {
    type: String,
    required: false
  },
  placeHolder: {
    type: String,
    required: false
  },
  disabled: Boolean
})

const emit = defineEmits(['update-text'])

const text = ref(props.initialText || '')

const isActive = ref(!!text.value)

const clearText = () => {
  text.value = ''
  emit('update-text', text.value) // Emit immediately after clearing
  isActive.value = false
}

watchDebounced(
  text,
  (newValue) => {
    if (newValue.length >= 3) {
      emit('update-text', newValue)
      isActive.value = true
    } else {
      emit('update-text', '')
      isActive.value = false
    }
  },
  { debounce: 300 }
)
</script>

<style scoped lang="scss">
@use '@/styles/ms-color-styles.scss' as color;

.ms-input-textbox {
  display: flex;
  height: 32px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  min-width: 96px;

  border: 1px solid color.$color-nordic-blue-base;
  background: color.$color-white;
  padding: 0px 8px;

  cursor: pointer;

  &.active {
    border-color: color.$color-nordic-blue-base;
  }
}

.ms-input-text {
  flex: 1;
  border: none;
  outline: none;
  padding: 0;
}

.btn-clear {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    color: color.$color-nordic-blue-base;
  }
}

.icon {
  flex-shrink: 0;
}
</style>
